export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakaznikVaria';
export const NAME = 'ZarazeniZakaznika';
